import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

let messaging: Messaging | null = null;

async function getFirebaseMessaging() {
    try {
        if (!('serviceWorker' in navigator && 'PushManager' in window)) {
            return messaging;
        }

        if(messaging !== null) return messaging;

        const firebaseConfig = {
            apiKey: "AIzaSyC8AhgBM3qRAj7V7zCJJrJ8Q89OWz8J4lQ",
            authDomain: "exp-ems.firebaseapp.com",
            projectId: "exp-ems",
            storageBucket: "exp-ems.appspot.com",
            messagingSenderId: "988212618696",
            appId: "1:988212618696:web:00aeac341ff49032160cfd",
            measurementId: "G-47SDDPBS9S"
        };
    
        // 初始化 Firebase
        const app = await initializeApp(firebaseConfig);
        messaging = await getMessaging(app);
    } catch (error: any) {
        console.error('firebase初期化失敗', JSON.stringify(error));
    }

    return messaging;
}

export { getFirebaseMessaging };


